import {motion} from 'framer-motion'
import {Button} from 'primereact/button'
import {Sidebar} from 'primereact/sidebar'
import React, {forwardRef, useImperativeHandle, useState} from 'react'
import Sheet from 'react-modal-sheet'

import TranslateUtils from '../../i18n/TranslateUtils'
import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from '../../utils/BlockScrollsUtils'
import useWindowSize from '../../utils/useWindowSize'
const ToolBoxWrapper = forwardRef(
    (
        {
            zIndex = 999,
            children,
            header = '',
            width = '30rem',
            icon = null,
            onSubmit = () => {},
            onToggleAudit = () => {},
            labelBtnInHead = '',
            iconBtnInHead = '',
            buttonInHead = false,
            auditLogActive = false,
            classNameBtnInHead = '',
            onSubmitButtonInHead = () => {},
        },
        ref,
    ) => {
        const [toggle, setToggle] = useState(false)
        const toggleToolBox = () => {
            setToggle(prev => !prev)
            blockOverflownScroll()
        }

        useImperativeHandle(ref, () => ({
            onShow: toggleToolBox,
        }))

        const windowSize = useWindowSize()
        const {translateDatatable} = TranslateUtils()

        const renderItem = (containerHeight = '') => {
            return (
                <React.Fragment>
                    <div className="flex justify-content-between">
                        <div className="flex gap-3 align-items-center">
                            {' '}
                            {icon ? icon : null}
                            <h4 className="my-2 text-700 font-bold">
                                {header}
                            </h4>
                        </div>
                        <div>
                            {!!buttonInHead && (
                                <Button
                                    label={labelBtnInHead}
                                    icon={iconBtnInHead}
                                    className={`${classNameBtnInHead} p-button-lg font-bold`}
                                    onClick={onSubmitButtonInHead}
                                />
                            )}
                        </div>
                    </div>
                    <hr />
                    <div className="" style={{height: containerHeight}}>
                        {children}
                    </div>
                    <hr />
                    <div className="">
                        {!auditLogActive ? (
                            <Button
                                label={translateDatatable(
                                    'Submit',
                                ).toUpperCase()}
                                icon="pi pi-send"
                                className="col-12 p-button-lg font-bold"
                                onClick={() => {
                                    onSubmit()
                                    setToggle(false)
                                }}
                            />
                        ) : (
                            <Button
                                label={translateDatatable('Back').toUpperCase()}
                                icon="pi pi-arrow-left"
                                className="col-12 p-button-lg font-bold"
                                onClick={() => {
                                    onToggleAudit()
                                }}
                            />
                        )}
                    </div>
                    <div className="p-10"></div>
                </React.Fragment>
            )
        }

        return (
            <div>
                {windowSize > 991 ? (
                    <Sidebar
                        position="right"
                        visible={toggle}
                        style={{width: width}}
                        onHide={() => {
                            setToggle(false)
                            onToggleAudit()
                            unblockOverflownScroll()
                        }}>
                        <motion.div
                            layout
                            transition={{layout: {duration: 0.15}}}
                            className="pt-3">
                            {renderItem('76vh')}
                        </motion.div>
                    </Sidebar>
                ) : (
                    <Sheet
                        style={{zIndex: zIndex}}
                        isOpen={toggle}
                        onClose={() => {
                            setToggle(false)
                            onToggleAudit()
                            unblockOverflownScroll()
                        }}>
                        <Sheet.Container>
                            <Sheet.Header />
                            <Sheet.Content className="col-12 px-3">
                                {renderItem('69vh')}
                            </Sheet.Content>
                        </Sheet.Container>
                        <Sheet.Backdrop />
                    </Sheet>
                )}
            </div>
        )
    },
)

export default ToolBoxWrapper
